<div class="payment-complete">
  <p [innerHTML]="'payment-panel-payment-complete_thank-you-confirmation-email' | translate: { 'email': options.user.email }"></p>
  <div class="order-details">
    <div class="order-details-header">
      <p class="bold" translate="payment-panel-payment-complete_order-details"></p>
      <button
        (click)="printOrderDetails()"
        attr.aria-label="{{ 'payment-panel-payment-complete_print_label' | translate }}"
        analytics-on="click"
        analytics-event="print-receipt"
        analytics-category="payment-complete"
        type="button"
        class="btn btn-none print-btn">
        <i class="ficon-app-print"></i>
      </button>
    </div>
    <div>

    </div>
    <ul class="order-details-body">
      <li class="order-details-item">
        <p class="bold" translate="payment-panel-payment-complete_order-number"></p>
        <p class="order-number">{{transaction.trans_id}}</p>
      </li>
      <li class="order-details-item">
        <p class="bold" translate="payment-panel-payment-complete_date"></p>
        <p class="order-date">{{transaction.created_at | date:'d MMM yyyy h:ss a'}}</p>
      </li>
      @if (ngxPurchaseTypeService.isLicenseInitialPurchase(options)) {
        <li class="license-details">
          <p class="bold" translate="payment-panel-review-payment_product"></p>
          <p><span translate="payment-panel-license-details_title"></span>:</p>
          @if (licenseDetails.selectedOrg) {
            <p><span translate="payment-panel-license-details_org-label"></span>: {{licenseDetails.selectedOrg.name}}</p>
          }
          <p>{{licenseDetails.licenseName}} - <span translate="{{licenseTypeTranslationKey}}"></span></p>
          <p><span translate="payment-panel-license-details_license-student-seats"></span>: {{licenseDetails.seats}}</p>
          <p>{{licenseDetails.licenseStartDate | date:'MM/dd/yyyy' }}-{{licenseDetails.licenseEndDate | date:'MM/dd/yyyy' }}</p>
        </li>
      }
      @if (ngxPurchaseTypeService.isLicenseSeatsPurchase(options)) {
        <li class="license-details">
          <p class="bold" translate="payment-panel-review-payment_product"></p>
          <p class="additional_seats"><span translate="payment-panel-license-details_license-seats-additional-label"></span>: {{licenseDetails.additional_seats}}</p>
          @if (licenseDetails.selectedOrg) {
            <p><span translate="payment-panel-license-details_org-label"></span>: {{licenseDetails.selectedOrg.name}}</p>
          }
          <p>{{licenseDetails.licenseName}} - <span translate="{{licenseTypeTranslationKey}}"></span></p>
        </li>
      }
      @if (!ngxPurchaseTypeService.isLicensePurchase(options)) {
        <li class="order-details-item">
          <p class="bold" translate="payment-panel-payment-complete_for"></p>
          <p class="product-name">{{group.name}}</p>
        </li>
      }
      <li class="order-details-item">
        <p class="bold" translate="payment-panel-payment-complete_method"></p>
        <p class="payment-method fullstory-ignore">XXXX-XXXX-XXXX-{{paymentMethod.details.lastFour}} {{paymentMethod.details.cardType}}</p>
      </li>
      <li class="order-details-item">
        <p class="bold" translate="payment-panel-payment-complete_payment"></p>
        <p class="product-price">{{ parseTotal(transaction.total) | currency: 'USD' }} USD</p>
      </li>
      <li class="order-details-item">
        <p class="bold" translate="payment-panel-payment-complete_email"></p>
        <p class="user-email">{{options.user.email}}</p>
      </li>
    </ul>
  </div>
</div>
